import PropTypes from "prop-types";

import { Grid, Paper, Stack, Typography } from "@mui/material";

import { formatDate } from "@/features/shared";

export const ReceiveClaimInformationSection = ({ receiveClaimData }) => {
  return (
    <Paper sx={{ p: 2.5, borderRadius: 2 }}>
      <Stack spacing={2.5}>
        <Typography variant="h6">Informasi Klaim Terima</Typography>

        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 4 }}>
            <Stack spacing={0.5}>
              <Typography variant="caption" sx={{
                color: "text.secondary"
              }}>
                Nomor Referensi Penerimaan Klaim
              </Typography>
              <Typography variant="body1">
                {receiveClaimData.referenceNumber}
              </Typography>
            </Stack>
          </Grid>

          <Grid size={{ xs: 12, sm: 4 }}>
            <Stack spacing={0.5}>
              <Typography variant="caption" sx={{
                color: "text.secondary"
              }}>
                Tanggal Transaksi
              </Typography>
              <Typography variant="body1">
                {formatDate(receiveClaimData.transactionDate)}
              </Typography>
            </Stack>
          </Grid>

          <Grid size={{ xs: 12, sm: 4 }}>
            <Stack spacing={0.5}>
              <Typography variant="caption" sx={{
                color: "text.secondary"
              }}>
                Outlet
              </Typography>
              <Typography variant="body1">
                {receiveClaimData.seller.name}
              </Typography>
            </Stack>
          </Grid>

          <Grid size={{ xs: 12, sm: 4 }}>
            <Stack spacing={0.5}>
              <Typography variant="caption" sx={{
                color: "text.secondary"
              }}>
                Pelanggan
              </Typography>
              <Typography variant="body1">
                {receiveClaimData.buyer.name}
              </Typography>
            </Stack>
          </Grid>

          <Grid size={{ xs: 12, sm: 4 }}>
            <Stack spacing={0.5}>
              <Typography variant="caption" sx={{
                color: "text.secondary"
              }}>
                Gudang
              </Typography>
              <Typography variant="body1">
                {receiveClaimData.warehouse.name}
              </Typography>
            </Stack>
          </Grid>

          <Grid size={{ xs: 12, sm: 4 }}>
            <Stack spacing={0.5}>
              <Typography variant="caption" sx={{
                color: "text.secondary"
              }}>
                Total Barang
              </Typography>
              <Typography variant="body1">
                {receiveClaimData.customerClaimProductVariants.length} item
              </Typography>
            </Stack>
          </Grid>
        </Grid>
      </Stack>
    </Paper>
  );
};

ReceiveClaimInformationSection.propTypes = {
  receiveClaimData: PropTypes.object.isRequired,
};
